/* Values FR59 asks the UI to show for features the backend does not have yet. Nothing here
 * stands in for an API response — every real conversation field still comes from the SDK.
 * Grouped so each can be retired on its own: flip its PENDING_BACKEND flag, then read the
 * real value at the call site. No layout change should be needed. */

export const PENDING_BACKEND = {
    // Blocked by: BE has no community conversation type.
    communities: true,
    // Blocked by: BE has no channel conversation type (FR87 follow/unfollow).
    channels: true,
    // Blocked by: FR188 / FR189 — chat tag list and creation are out of FR59 scope.
    chatTags: true,
    // Blocked by: the Home module (FR30) is not built yet.
    homeRail: true,
    // Blocked by: the Services hub is not built yet.
    servicesRail: true,
};

// Fixed design values, not counts of anything. 0 hides the badge.
export const STATIC_HOME_BADGE = 0;
export const STATIC_SERVICES_BADGE = 0;

// No conversation carries these types yet, but FR59 still requires both chips.
export const STATIC_COMMUNITY_COUNT = 0;
export const STATIC_CHANNEL_COUNT = 0;
